import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  INFORMATION_LIST,
  ARTICLE_LIST,
  WHAT_SNEWS,
  NEEDINPUT_STATUS,
  API_URL_MYPAGE_RECOMMEND,
} from 'manager/http-constants';
import { AuthorityDecision } from 'manager/user-authority-constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { LoginService } from 'src/app/shared/service/login.service';
import { PlatformComponent } from '../platform.component';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';

@Component({
  selector: 'app-b301',
  templateUrl: './b301.component.html',
  styleUrls: ['./b301.component.scss', '../platform.component.scss'],
})

/**
 * マイページ
 */
export class B301Component extends PlatformComponent {
  // 最近の更新（最近1ヶ月）格納先
  updateDataList: object[] = [];

  // 事務局からのお知らせ格納先
  noticeDataList: object[] = [];

  // レコメンド格納先
  resultRecommendList: object[] = [];

  // 事例紹介記事
  articleDataList: object[] = [];

  // 事務局からのお知らせ格納先
  needinputList: any;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {
    // ログインユーザーが存在するか否か
    if (!this.loginUser) {
      // ログインユーザーが存在する場合

      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart();

      // ログインユーザ情報取得処理
      this.loginService.getLoginUser().subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3);

        // ログインユーザ情報がユーザマスタに存在するか否か
        if (this.commonService.checkNoneResponse(response)) {
          // ユーザマスタに存在しない場合

          // 不正なユーザの為、ログアウト処理
          this.loginService.logout(MESSAGE_CODE.E90000);

          // 処理を終了
          return;
        } else {
          // ユーザマスタに存在する場合

          this.loginUser = response.body[0];

          // レコメンド取得
          this.getRecommendData();
        }
      });
    } else {
      // レコメンド取得
      this.getRecommendData();
    }

    // 最近の更新（最近1ヶ月）を取得
    this.getUpdateData();

    // 事務局からのお知らせを取得
    this.getNoticeData();

    // 事例紹介記事を取得
    this.getArticleData();

    // 未登録情報を取得
    this.getNeedInput();

    // 代行会員情報を初期化
    this.initAltUserBySecretariat();
  }

  /**
   * 最近の更新（最近1ヶ月）を取得
   */
  private getUpdateData(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(WHAT_SNEWS);

    // 最近の更新（最近1ヶ月）を取得
    this.dbOperationService
      .getNoTemplateData(WHAT_SNEWS)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 最近の更新（最近1ヶ月）を格納
          this.updateDataList = response.body;
        } else {
          this.updateDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, WHAT_SNEWS);
      });
  }
  /**
   * 会員プロフィール未登録項目チェックを取得
   */
  private getNeedInput(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(NEEDINPUT_STATUS);

    // 会員プロフィール未登録項目チェックを取得
    this.dbOperationService
      .getNoTemplateData(NEEDINPUT_STATUS, {}, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 会員プロフィール未登録項目チェックを格納
          this.needinputList = response.body;
        } else {
          this.needinputList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, NEEDINPUT_STATUS);
      });
  }

  /**
   * 事務局からのお知らせを取得
   */
  private getNoticeData(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(INFORMATION_LIST);

    // お知らせ一覧を取得
    this.dbOperationService
      .getNoTemplateData(
        INFORMATION_LIST,
        { information_kbn: 4, publishe: 1 },
        true
      )
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // お知らせ一覧を格納
          this.noticeDataList = response.body;
        } else {
          this.noticeDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, INFORMATION_LIST);
      });
  }

  /**
   * レコメンドを取得
   */
  private getRecommendData(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_MYPAGE_RECOMMEND);

    // レコメンド一覧を取得
    this.dbOperationService
      .getNoTemplateData(API_URL_MYPAGE_RECOMMEND, { "member_id": this.loginUser.member_id })
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // レコメンド一覧を格納
          this.resultRecommendList = response.body;
        } else {
          this.resultRecommendList = new Array();
        }
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_MYPAGE_RECOMMEND);
      });
  }

  /**
   * 事例紹介記事
   */
  private getArticleData(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(ARTICLE_LIST);

    // お知らせ一覧を取得
    this.dbOperationService
      .getNoTemplateData(
        ARTICLE_LIST,
        {freeword: ''},
        true
      )
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // お知らせ一覧を格納
          this.articleDataList = response.body.slice(0, 4);
        } else {
          this.articleDataList = [];
        }

        while (this.articleDataList.length < 4) {
          this.articleDataList.push({
            article_url: null,
            article_image: { file_path: '' },
            title: '',
            description: '',
            update_datetime: null,
            is_filler: true
          });
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, ARTICLE_LIST);
      });
  }

  /**
   * 会員プロフィール(B211 or B212)へ遷移する
   */
  public moveB211orMoveB212(): void {
    // 自治体 or 事務局ユーザが否か
    if (
      this.commonService.decisionUserAuthority(
        false,
        new AuthorityDecision({
          user_1: true,
          user_4: true,
        })
      )
    ) {
      // 自治体 or 事務局ユーザの場合

      // 会員プロフィール(自治体)(B211)へ遷移
      this.router.navigate(['pages/platform/b211/' + this.loginUser.member_id]);
    } else {
      // 民間団体の場合

      // 会員プロフィール(民間団体)(B212)へ遷移
      this.router.navigate(['pages/platform/b212/' + this.loginUser.member_id]);
    }
  }

  /**
   *  課題・ソリューション登録(C101)へ遷移する
   * @param agendaKbn 区分 1:課題　2:ソリューション
   */
  public moveC101(agendaKbn: number): void {
    // 課題・ソリューション登録(C101)へ遷移
    this.router.navigate(['pages/platform/c101/new'], {
      queryParams: {
        screenId: 'c101',
        agenda_kbn: agendaKbn,
      },
    });
  }

  /**
   * 連携事例(H101)へ遷移する
   */
  public moveH101(): void {
    // 連携事例登録(H101)へ遷移
    this.router.navigate(['pages/platform/h101/new'], {
      queryParams: {
        screenId: 'h101',
      },
    });
  }

  /**
 * ユーザ管理一覧(B220)へ遷移する
 */
  public moveB220(): void {
    // ユーザ管理一覧(B220)へ遷移
    this.router.navigate(['pages/platform/b220']);
  }

  /**
   * マッチング依頼一覧(C502)へ遷移する
   */
  public moveC502(): void {
    // マッチング依頼一覧(C502)へ遷移
    this.router.navigate(['pages/platform/c502']);
  }

  /**
   *事務局(D101)へ遷移する
   */
  public moveD101(): void {
    // 事務局(D101)へ遷移
    this.router.navigate(['pages/platform/d101']);
  }

  /**
   * イベント申請一覧(E103)へ遷移する
   */
  public moveE103(): void {
    // イベント申請一覧(E103)へ遷移
    this.router.navigate(['pages/platform/e103']);
  }

  /**
   * 分科会申請一覧(E203)へ遷移する
   */
  public moveE203(): void {
    // 分科会申請一覧(E203)へ遷移
    this.router.navigate(['pages/platform/e203']);
  }

  /**
   * 課題・ソリューション管理(C104)へ遷移する
   */
  public moveC104(): void {
    // 課題・ソリューション管理(C104)へ遷移
    this.router.navigate(['pages/platform/c104']);
  }

  /**
   * 連携事例管理(H104)へ遷移する
   */
  public moveH104(): void {
    // 連携事例管理(H104)へ遷移
    this.router.navigate(['pages/platform/h104']);
  }

  /**
   * 更新された画面へ遷移する
   * @param updateData 更新情報
   */
  public moveScreen(updateData: any): void {
    // 会員ID（追加、更新、削除）の存在チェック
    if (updateData.member_id_src) {
      // 会員ID（追加、更新、削除）が存在する場合

      if (1 == updateData.class_id || 9 == updateData.class_id) {
        // 会員プロフィール(自治体)(B211)へ遷移
        this.router.navigate([
          'pages/platform/b211/' + updateData.member_id_src,
        ]);
      } else {
        // 会員プロフィール(民間団体)(B212)へ遷移
        this.router.navigate([
          'pages/platform/b212/' + updateData.member_id_src,
        ]);
      }
    }

    // ユーザID（追加、更新、削除）の存在チェック
    if (updateData.user_id_src != 0) {
      // ユーザID（追加、更新、削除）が存在する場合

      // ユーザー一覧(B220)へ遷移
      this.router.navigate(['pages/platform/b220']);
    }

    // 課題ID（追加、更新、削除）の存在チェック
    if (updateData.agenda_id_src != 0) {
      // 課題ID（追加、更新、削除）が存在する場合

      // 課題・ソリューション詳細(C301)へ遷移
      this.router.navigate(['pages/platform/c301/' + updateData.agenda_id_src]);
    }

    // 掲示板ID（追加、更新、削除）の存在チェック
    if (updateData.board_id_src != 0) {
      // 掲示板ID（追加、更新、削除）が存在する場合

      // 課題・ソリューション詳細(C301)へ遷移
      this.router.navigate(['pages/platform/c301/' + updateData.board_id_src]);
    }

    // 提案ID（追加、更新、削除）の存在チェック
    if (updateData.suggest_id_src != 0) {
      // 提案ID（追加、更新、削除）が存在する場合

      // 提案詳細(C601)へ遷移
      this.router.navigate([
        'pages/platform/c601/' + updateData.suggest_id_src,
      ]);
    }

    // 会員主催イベントID（追加、更新、削除）の存在チェック
    if (updateData.member_event_id_src != 0) {
      // 会員主催イベントID（追加、更新、削除）が存在する場合

      // 会員主催イベント詳細(E102)へ遷移
      this.router.navigate([
        'pages/platform/e102/' + updateData.member_event_id_src,
      ]);
    }

    // 分科会ID（追加、更新、削除）の存在チェック
    if (updateData.subcommittee_id_src != 0) {
      // 分科会ID（追加、更新、削除）が存在する場合

      // 分科会詳細(E202)へ遷移
      this.router.navigate([
        'pages/platform/e202/' + updateData.subcommittee_id_src,
      ]);
    }

    // 連携事例ID（追加、更新、削除）の存在チェック
    if (updateData.cooperation_id_src != 0) {
      // 連携事例ID（追加、更新、削除）が存在する場合

      // 連携事例詳細(h301)へ遷移
      this.router.navigate(['pages/platform/h301/' + updateData.cooperation_id_src]);
    }
  }

  /**
   * 更新された画面へ遷移する
   * @param recommendData 更新情報
   */
  public moveScreenRecommend(recommendData: any): void {
    // 区分：課題・ソリューション
    if (recommendData.kbn == 1 || recommendData.kbn == 2) {
      // 課題・ソリューション詳細(C301)へ遷移
      window.open('pages/platform/c301/' + recommendData.id);
    } else if (recommendData.kbn == 3) {
      // 区分：連携事例
      // 連携事例詳細(h301)へ遷移
      window.open('pages/platform/h301/' + recommendData.id);
    }
  }

  /**
   * 更新日時が一ヶ月以内課のチェック
   * @param dateString 更新日時
   */
  public isWithinLastMonth(dateString: string | undefined): boolean {
    const updateDate = dateString ? new Date(dateString) : null;
    if (!updateDate) { return false; }

    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    updateDate.setHours(0, 0, 0, 0);
    oneMonthAgo.setHours(0, 0, 0, 0);

    return updateDate >= oneMonthAgo;
  }


}
